import styled from 'styled-components';

export const CategoryWrapper = styled.div`
  padding: 16px 0 0;
  // border-top: 1px solid #ccc;
`;

export const Title = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: rgb(56, 56, 61);
  margin-bottom: 12px;
  margin-top: 0px;
`;

export const MenuGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  column-gap: 20px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 992px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (min-width: 1200px) {
    grid-template-columns: repeat(5, 1fr);
  }
`;

export const MenuColumn = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: rgb(128, 128, 137);
  margin-bottom: 12px;
  margin-top: 0px;

  p {
    font-size: 12px;
    line-height: 16px;
    color: rgb(128, 128, 137);
    margin-bottom: 12px;
    margin-top: 0px;
  }

  a {
    color: rgb(128, 128, 137);
  }
`;

export const MenuSubHeading = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: rgb(56, 56, 61);
  margin-bottom: 4px;
  margin-top: 0px;
`;
